<div class="container" [ngClass]="{ 'in-dialog': isInDialog }">
    <form [formGroup]="addressForm" class="form-container">
        <div class="input-field" *ngIf="showNameAndMobile">
            <label for="id" class="required">{{ "addressDetails.label.name" | translate }}</label>
            <input
                id="name"
                type="text"
                formControlName="name"
                class="location-input"
                [placeholder]="'addressDetails.placeholder.name' | translate"
                maxlength="50"
            />
            <div *ngIf="isInvalid('name')">
                <div *ngIf="isInvalid('name', 'required')" class="text-red">
                    {{ "addressDetails.label.name" | translate }}
                    {{ "addressDetails.invalidMessage.mandatory" | translate }}
                </div>
                <div *ngIf="isInvalid('name', 'forbiddenName')" class="text-red">
                    {{ "addressDetails.label.name" | translate }}
                    {{ "addressDetails.invalidMessage.numberSpecialInvalid" | translate }}
                </div>
            </div>
        </div>
        <div class="input-field" *ngIf="showNameAndMobile">
            <label for="mobileNumber" class="required">{{ "addressDetails.label.phoneNo" | translate }}</label>
            <input
                id="mobileNumber"
                type="text"
                class="location-input"
                formControlName="mobileNumber"
                [placeholder]="'addressDetails.placeholder.phoneNo' | translate"
                (input)="onValidNumber($event)"
                maxlength="10"
                minlength="10"
            />
            <div *ngIf="isInvalid('mobileNumber')">
                <div *ngIf="isInvalid('mobileNumber', 'required')" class="text-red">
                    {{ "addressDetails.label.phoneNo" | translate }}
                    {{ "addressDetails.invalidMessage.mandatory" | translate }}
                </div>
                <div
                    *ngIf="isInvalid('mobileNumber', 'indianPhoneNumber') && !isInvalid('mobileNumber', 'required')"
                    class="text-red"
                >
                    {{ "addressDetails.invalidMessage.mobileNoInvalid" | translate }}
                </div>
            </div>
        </div>
        <div class="input-field house-field">
            <label for="houseNumber" class="required">{{ "addressDetails.label.house&Floor" | translate }}</label>
            <input
                id="houseNumber"
                type="text"
                formControlName="houseNumber"
                class="location-input"
                [placeholder]="'addressDetails.placeholder.house&Floor' | translate"
                required
            />
            <div *ngIf="isInvalid('houseNumber')">
                <div *ngIf="isInvalid('houseNumber', 'required')" class="text-red">
                    {{ "addressDetails.label.house&Floor" | translate }}
                    {{ "addressDetails.invalidMessage.mandatory" | translate }}
                </div>
            </div>
        </div>
        <div class="input-field">
            <label for="address" class="required">{{ "addressDetails.label.address" | translate }}</label>
            <input
                id="address"
                type="text"
                formControlName="address"
                class="location-input"
                [placeholder]="'addressDetails.placeholder.address' | translate"
                required
            />
            <div *ngIf="isInvalid('address')">
                <div *ngIf="isInvalid('address', 'required')" class="text-red">
                    {{ "addressDetails.label.address" | translate }}
                    {{ "addressDetails.invalidMessage.mandatory" | translate }}
                </div>
            </div>
        </div>
        <div class="input-field">
            <label for="city" class="required">{{ "addressDetails.label.city" | translate }}</label>
            <input
                id="city"
                type="text"
                formControlName="city"
                class="location-input"
                [placeholder]="'addressDetails.placeholder.city' | translate"
                required
            />
            <div *ngIf="isInvalid('city')">
                <div *ngIf="isInvalid('city', 'required')" class="text-red">
                    {{ "addressDetails.label.city" | translate }}
                    {{ "addressDetails.invalidMessage.mandatory" | translate }}
                </div>
            </div>
        </div>

        <div class="pincode-state">
            <div class="input-field pincode-field">
                <label for="pincode" class="required">{{ "addressDetails.label.pincode" | translate }}</label>
                <input
                    id="pincode"
                    matInput
                    type="text"
                    formControlName="pincode"
                    class="location-input"
                    [placeholder]="'addressDetails.placeholder.pincode' | translate"
                    (input)="onValidNumber($event)"
                    maxlength="6"
                    required
                />
                <div *ngIf="isInvalid('pincode')">
                    <div *ngIf="isInvalid('pincode', 'required')" class="text-red">
                        {{ "addressDetails.label.pincode" | translate }}
                        {{ "addressDetails.invalidMessage.mandatory" | translate }}
                    </div>
                    <div
                        *ngIf="isInvalid('pincode', 'invalidPincode') && !isInvalid('pincode', 'required')"
                        class="text-red"
                    >
                        {{ "addressDetails.label.pincode" | translate }}
                        {{ "addressDetails.invalidMessage.pincodeInvalid" | translate }}
                    </div>
                </div>
            </div>
            <div class="input-field state-field">
                <label for="state" class="required">{{ "addressDetails.label.state" | translate }}</label>
                <input
                    id="state"
                    type="text"
                    formControlName="state"
                    class="location-input"
                    [placeholder]="'addressDetails.placeholder.state' | translate"
                    required
                />
                <div *ngIf="isInvalid('state')">
                    <div *ngIf="isInvalid('state', 'required')" class="text-red">
                        {{ "addressDetails.label.state" | translate }}
                        {{ "addressDetails.invalidMessage.mandatory" | translate }}
                    </div>
                </div>
            </div>
        </div>

        <div class="input-field">
            <label for="addressType" class="required">{{ "addressDetails.label.addressType" | translate }} </label>
            <mat-chip-listbox id="addressType" formControlName="addressType">
                <mat-chip-option [value]="'addressDetails.label.home' | translate">
                    {{ "addressDetails.label.home" | translate }}
                </mat-chip-option>
                <mat-chip-option [value]="'addressDetails.label.work' | translate">
                    {{ "addressDetails.label.work" | translate }}
                </mat-chip-option>
                <mat-chip-option [value]="'addressDetails.label.other' | translate">
                    {{ "addressDetails.label.other" | translate }}
                </mat-chip-option>
            </mat-chip-listbox>
        </div>

        <div *ngIf="showDefaultAddress && !address?.isDefault">
            <mat-checkbox formControlName="isDefault" (change)="toggleDefault($event)">
                {{ "addressDetails.label.setDefault" | translate }}
            </mat-checkbox>
        </div>
    </form>
</div>
